<template>
	<div class="form" id="password-form">
		<div class="row">
			<h1 class="form__title">Esqueci minha senha</h1>
		</div>
		<p class="form__text">Agora você já pode alterar sua senha novamente:</p>
		<div class="field">
			<label class="field__label" for="login"> Nova senha </label>
			<InputPassword
				:class="(validatedPasswords && password) || !password ? 'approved' : 'deny'"
				id="password-input"
				v-model="password"
			/>
		</div>
		<div class="field">
			<label class="field__label" for="login"> Confirmar nova senha </label>
			<InputPassword
				:class="(validatedPasswords && confirmPassword) || !confirmPassword ? 'approved' : 'deny'"
				id="confirm-password-input"
				v-model="confirmPassword"
			/>
		</div>
		<PasswordRules
			ref="passwordRules"
			:password="password"
			:confirmPassword="confirmPassword"
			:big="true"
		/>
		<div class="actions">
			<div class="actions__btn">
				<button id="back-btn" class="actions__btn-back" @click="goToLogin()">Voltar</button>
				<button
					id="next-btn"
					class="actions__btn-next"
					:class="isLoadingNewPassword ? 'disabled' : ''"
					@click="validateField()"
				>
					<span v-if="!isLoadingNewPassword">Próximo</span>
					<SpinnerIcon :color="'#1c2541'" v-else />
				</button>
			</div>
		</div>
	</div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import { CREATE_NEW_PASSWORD } from '@/store/modules/login/forgotPassword/actions';
import CryptoJS from 'crypto-js';
import InputPassword from '@/components/shared/InputPassword/InputPassword.vue';
import PasswordRules from '@/components/modules/Login/PasswordRules/PasswordRules.vue';
import SpinnerIcon from '@/components/shared/Icons/SpinnerIcon.vue';

export default {
	name: 'PasswordForm',
	components: {
		InputPassword,
		PasswordRules,
		SpinnerIcon,
	},
	data: () => ({
		isLoadingEmail: false,
		password: '',
		confirmPassword: '',
	}),
	mounted() {},
	methods: {
		...mapActions('forgotPassword', {
			newPassReq: CREATE_NEW_PASSWORD,
		}),
		goToLogin() {
			this.$router.push('/login');
		},
		validatedPasswords() {
			return this.$refs.passwordRules.validatedPasswords();
		},
		validateField() {
			if (!this.validatedPasswords()) return;

			this.recoverPassword();
		},
		recoverPassword() {
			this.isLoadingEmail = true;
			const userPassword = this.password;
			let token = this.$route.query.token;
			let lastFour = token.substr(token.length - 4);

			const fixedKey = process.env.VUE_APP_FIXED_KEY;
			const getEmailChars = lastFour;

			let timestamp = new Date().toISOString();
			let formatHour = this.$moment(new Date(timestamp)).format('HH:mm:ss');
			formatHour = formatHour.replace(new RegExp(':', 'g'), '');

			const key = `${fixedKey}${getEmailChars}${formatHour}`;
			const encryptedPassword = CryptoJS.AES.encrypt(userPassword, key);
			token = token.split(lastFour)[0];

			const body = {
				token: token,
				timestamp: timestamp,
				encryptedPassword: encryptedPassword.toString(),
			};

			this.newPassReq({ body, vm: this })
				.then((res) => {
					if (res.status == 201) {
						this.$emit('handleSuccess');
					}
				})
				.catch(() => {});
		},
	},
	computed: {
		...mapGetters('forgotPassword', ['isLoadingNewPassword']),
	},
};
</script>

<style lang="scss" scoped>
@import 'PasswordForm.scss';
</style>
